{
  "REGISTER": {
    "TRY_WOOT": "Створити акаунт",
    "TITLE": "Реєстрація",
    "TESTIMONIAL_HEADER": "Один крок і вперед",
    "TESTIMONIAL_CONTENT": "Ви за один крок від залучення своїх клієнтів, утримання їх та пошуку нових.",
    "TERMS_ACCEPT": "Зареєструвавшись, ви погоджуєтеся з нашими <a href=\"https://chat.jarabot.com/terms\">Умовами Користування</a> та <a href=\"https://chat.jarabot.com/privacy-policy\">Політикою конфіденційності</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "Зареєструватися через Google"
    },
    "COMPANY_NAME": {
      "LABEL": "Назва компанії",
      "PLACEHOLDER": "Введіть ім'я вашої компанії. Наприклад Wayne Enterprises",
      "ERROR": "Назва компанії закоротка."
    },
    "FULL_NAME": {
      "LABEL": "Повне ім'я",
      "PLACEHOLDER": "Введіть ваше повне ім'я. Наприклад Брюс Вейн",
      "ERROR": "Повне ім’я занадто коротке."
    },
    "EMAIL": {
      "LABEL": "Робоча електронна пошта",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "Будь ласка, введіть робочу адресу електронної пошти."
    },
    "PASSWORD": {
      "LABEL": "Пароль",
      "PLACEHOLDER": "Пароль",
      "ERROR": "Пароль занадто короткий.",
      "IS_INVALID_PASSWORD": "Пароль повинен містити принаймні 1 велику літеру, хоча б 1 малу літеру, 1 цифру та 1 спеціальний символ."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Підтвердити пароль",
      "PLACEHOLDER": "Підтвердити пароль",
      "ERROR": "Пароль не підходить."
    },
    "API": {
      "SUCCESS_MESSAGE": "Реєстрація пройшла успішно",
      "ERROR_MESSAGE": "Не вдалося підключитися до Woot сервера. Будь ласка, спробуйте ще раз."
    },
    "SUBMIT": "Створити акаунт",
    "HAVE_AN_ACCOUNT": "Вже маєте обліковий запис?",
    "TERMS_LINKS": "<a href=\"https://chat.jarabot.com/terms\">Умови використання</a> - <a href=\"https://chat.jarabot.com/privacy-policy\">Політика конфіденційності</a>"
  }
}
